import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import websiteConfigurationActions from "../../store/actions/websiteConfigurations/websiteConfiguration.actions";

const useWebsiteConfiguration = (configKey = null) => {
  const dispatch = useDispatch();

  // Get the entire website configuration state from Redux
  const configurations = useSelector((state) => state.websiteConfigurationReducer.configurations) || [];

  // Re-parse all configurations into a key-value object
  const allConfigurations = useMemo(() => {
    return configurations.reduce((acc, config) => {
      try {
        acc[config.key] = JSON.parse(config.value);
      } catch (error) {
        console.error(`Error parsing configuration for key: ${config.key}`, error);
        acc[config.key] = null;
      }
      return acc;
    }, {});
  }, [configurations]);

  // Return only the value for the specific key (if provided)
  const configurationValue = useMemo(() => {
    if (!configKey) return null;
    return allConfigurations[configKey] ?? null;
  }, [configKey, allConfigurations]);

  // Trigger refetch (by reloading all configurations)
  const refetch = () => {
    dispatch(websiteConfigurationActions.getAllConfigurations());
  };

  return { allConfigurations, configurationValue, refetch };
};

export default useWebsiteConfiguration;
